export const lotInventoryStrings = {
  menuTitle: "Inventario de lotes",
  hubTitle: "Inventario de lotes",
  hubSearchPlaceholder: "Buscar proyecto…",
  hubColProject: "Proyecto",
  hubColLotsAvailable: "Lotes disponibles",
  hubColCommercialAvailable: "Locales disponibles",
  hubColSummary: "Resumen",
  hubEmpty: "No hay proyectos.",
  hubOpen: "Abrir inventario",
  hubPublicStock: "Inventario público",
  statusAvailable: "Disponible",
  statusSold: "Vendido",
  statusHold: "Separado",
  statusLocked: "Bloqueado",
  kindLots: "Lotes",
  kindCommercial: "Locales comerciales",
  workspaceBack: "Volver al inventario",
  viewBoard: "Tablero",
  viewTable: "Tabla",
  viewMap: "Mapa",
  mapUploadTitle: "Mapa KML",
  mapUploadHint:
    "Sube el KML de polígonos (carpeta Lotes). Nombres 1-12 / 2-3 o ExtendedData stageKey+lotNumber. Sin etapa en el nombre: oeste→1, este→2. El estado se pinta desde el inventario.",
  mapUploadDrop: "Suelta un archivo .kml o haz clic para elegir",
  mapUploadButton: "Subir mapa",
  mapSwapStages: "Invertir etapas 1 ↔ 2",
  mapClear: "Quitar mapa",
  mapUploadResult: "Mapa listo: {features} polígonos, {created} lotes creados.",
  mapLegend: "Leyenda",
  mapUnmatched: "Sin match",
  mapMatched: "vinculados",
  mapMissing: "Aún no hay mapa. Un administrador debe subir el KML.",
  mapEmpty: "No hay polígonos para mostrar con los filtros actuales.",
  mapMissingToken:
    "Configura VITE_MAPBOX_ACCESS_TOKEN en el .env para ver el mapa satelital.",
  mapView2d: "2D",
  mapView3d: "3D",
  uploadsButton: "Importar archivos",
  uploadsDialogTitle: "Importar Excel / KML",
  uploadsDialogClose: "Cerrar",
  searchLotPlaceholder: "Buscar por número…",
  selectMode: "Seleccionar",
  applyStatus: "Aplicar estado",
  clearSelection: "Limpiar",
  selectedCount: "seleccionados",
  colNumber: "Nº",
  colStage: "Etapa",
  colArea: "Área (m²)",
  colPrice: "Precio",
  colStatus: "Estado",
  colVentor: "Vendedor",
  colSoldBy: "Cliente",
  drawerTitle: "Lote",
  drawerSave: "Guardar",
  fieldArea: "Área (m²)",
  fieldPrice: "Precio (COP)",
  fieldVentor: "Nombre del vendedor",
  fieldSoldBy: "ID cliente (opcional)",
  fieldHoldUntil: "Límite de separación",
  fieldHoldUntilHelper: "Por defecto: 24 horas. Al vencer, el lote vuelve a disponible.",
  holdUntilRequired: "Indica la fecha límite de separación",
  holdUntilPast: "La fecha límite debe ser futura",
  colHoldUntil: "Límite separación",
  excelTitle: "Importar Excel",
  excelHint:
    "Encabezados requeridos: stage, nLots, area, price, status (V=vendido, S=separado, C=bloqueado). stage vacío → Etapa 1. Opcional: ventor, stageName. Precio acepta $ 52.000.000",
  excelDrop: "Suelta un archivo .xlsx o haz clic para elegir",
  excelImport: "Importar",
  excelClearFile: "Quitar archivo",
  excelClearInventory: "Borrar inventario",
  excelClearInventoryTitle: "¿Borrar inventario Excel?",
  excelClearInventoryHint:
    "Esto elimina todos los lotes y locales de este proyecto en la base de datos. El mapa KML no se borra. Luego puedes importar un archivo nuevo.",
  excelClearInventoryConfirm: "Borrar inventario",
  excelClearInventoryCancel: "Cancelar",
  excelClearInventorySuccess: "Inventario eliminado. Ya puedes importar un archivo nuevo.",
  excelTemplate: "Descargar plantilla",
  excelResult: "Importación",
  excelCreated: "creados",
  excelUpdated: "actualizados",
  excelErrors: "errores",
  generateTitle: "Generar inventario",
  generateButton: "Generar lotes",
  generateNLots: "Cantidad de lotes",
  generateNCommercial: "Cantidad de locales",
  generateBaseLotArea: "Área base lotes (m²)",
  generateBaseCommercialArea: "Área base locales (m²)",
  generateDefaultLotPrice: "Precio por defecto lotes",
  generateDefaultCommercialPrice: "Precio por defecto locales",
  generateConfirm: "Generar unidades faltantes",
  generateSuccess: "Inventario generado",
  pctSold: "% vendido",
  loading: "Cargando…",
  errorGeneric: "Ocurrió un error",
  noLots: "Aún no hay unidades. Un administrador debe generar el inventario.",
  filterAll: "Todos",
  filterAllStages: "Todas las etapas",
  stageGeneral: "General",
  fieldStage: "Etapa",
  fieldStageReadOnly: "La etapa se define al importar Excel",
  bulkApplied: "Estado actualizado",
  saveSuccess: "Lote actualizado",
  historyTitle: "Historial de estados",
  historyEmpty: "Sin cambios registrados.",
  historyActor: "Usuario",
  historySystem: "Sistema",
  desistButton: "Desistir compra",
  desistTitle: "Desistir compra",
  desistHint: "Adjunta al menos un comprobante (PDF, JPG, PNG o WEBP). El lote volverá a disponible.",
  desistNote: "Nota (opcional)",
  desistFiles: "Evidencia",
  desistFilesRequired: "Adjunta al menos un archivo",
  desistConfirm: "Confirmar desistimiento",
  desistCancel: "Cancelar",
  desistSuccess: "Compra desistida. El lote está disponible.",
  desistSoldOnly: "Solo se puede desistir un lote vendido.",
  statusSoldLocked: "Para volver a disponible usa Desistir compra."
} as const
